import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL || "";

// Fetch all courses
export const fetchCourses = async (signal?: AbortSignal) => {
  const endpoint = `${baseUrl}/course/bk-course`;
  try {
    const response = await axios.get(endpoint, { signal });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching courses:", error);
    return [];
  }
};

// Fetch course tracks
export const fetchCourseTracks = async (signal?: AbortSignal) => {
  const endpoint = `${baseUrl}/course/bk-track`;
  try {
    const response = await axios.get(endpoint, { signal });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching course tracks:", error);
    return [];
  }
};

// Fetch Blog Posts
export const fetchBlogPosts = async (signal?: AbortSignal) => {
  const endpoint = `${baseUrl}/blog/post-list`;
  try {
    const response = await axios.get(endpoint, { signal });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching blog posts:", error);
    return [];
  }
};

export const fetchOurServices = async (signal?: AbortSignal) => {
  const endpoint = `${baseUrl}/our-services`;
  try {
    const response = await axios.get(endpoint, { signal });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching our services:", error);
    return [];
  }
};

export const fetchOurJobs = async (signal?: AbortSignal) => {
  const endpoint = `${baseUrl}/our-recent-jobs`;
  try {
    const response = await axios.get(endpoint, { signal });
    return Array.isArray(response.data) ? response.data : [];
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    console.error("Error fetching our jobs:", error);
    return [];
  }
};

// Fetch company & landing static data bundle
export interface LandingBundleData {
  testimonials: any[];
  ourTeam: any[];
  workProcess: any[];
  industry: any[];
  tech: any[];
  coreValue: any[];
  client: any[];
  companyInfo: any;
  jobOpenings: any[];
  courseHero: any;
}

export const fetchLandingBundle = async (signal?: AbortSignal): Promise<LandingBundleData> => {
  const apiUrl = baseUrl;
  const responses = await Promise.all([
    axios.get(`${apiUrl}/testimonials`, { signal }),
    axios.get(`${apiUrl}/our-teams`, { signal }),
    axios.get(`${apiUrl}/work-process`, { signal }),
    axios.get(`${apiUrl}/industries`, { signal }),
    axios.get(`${apiUrl}/technologies`, { signal }),
    axios.get(`${apiUrl}/core-values`, { signal }),
    axios.get(`${apiUrl}/clients`, { signal }),
    axios.get(`${apiUrl}/company-info/1`, { signal }),
    axios.get(`${apiUrl}/our-jobs`, { signal }),
    axios.get(`${apiUrl}/course/bk-course-hero`, { signal }),
  ]);

  return {
    testimonials: Array.isArray(responses[0]?.data) ? responses[0].data : [],
    ourTeam: Array.isArray(responses[1]?.data) ? responses[1].data : [],
    workProcess: Array.isArray(responses[2]?.data) ? responses[2].data : [],
    industry: Array.isArray(responses[3]?.data) ? responses[3].data : [],
    tech: Array.isArray(responses[4]?.data) ? responses[4].data : [],
    coreValue: Array.isArray(responses[5]?.data) ? responses[5].data : [],
    client: Array.isArray(responses[6]?.data) ? responses[6].data : [],
    companyInfo: responses[7]?.data || {},
    jobOpenings: Array.isArray(responses[8]?.data) ? responses[8].data : [],
    courseHero: responses[9]?.data || {},
  };
};
